import { Helmet } from "react-helmet-async";

const jsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "Bati Rui",
  description: "Entreprise de rénovation tous corps d'état à Paris depuis 2011",
  url: "https://www.batirui.com",
  telephone: "+33632255275",
  address: {
    "@type": "PostalAddress",
    streetAddress: "45 rue de l'Espérance",
    addressLocality: "Paris",
    postalCode: "75013",
    addressCountry: "FR",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 48.8234,
    longitude: 2.3524,
  },
  areaServed: "Ile-de-France",
  foundingDate: "2011",
  numberOfEmployees: "6-9",
  priceRange: "$$",
};

export default function SEO({ title, description, canonical }) {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonical} />
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
